import styled from 'styled-components';
import {
  flexBoxCenter,
  layerDegHPA,
  layerHPA,
} from '../../../../styles/commonStyles';

const MainSitePlanBox = () => {
  return (
    <Wrapper>
      <FirstInnerLayer>
        <SecondInnerLayer></SecondInnerLayer>
      </FirstInnerLayer>
    </Wrapper>
  );
};

export default MainSitePlanBox;

const Wrapper = styled.div`
  height: 100%;
  width: 100%;

  border-radius: 10px;
  ${layerHPA}
  ${flexBoxCenter}
`;

const FirstInnerLayer = styled.div`
  height: 184px;
  width: 867px;

  border-radius: 8px;
  ${layerDegHPA}
  box-shadow: none;
  ${flexBoxCenter}
`;

const SecondInnerLayer = styled.div`
  height: 176px;
  width: 857px;

  border-radius: 4px;
  ${layerHPA}

  ${flexBoxCenter}
`;
